import { FC, Suspense } from "react";
import { VerticalTab } from "@/components/VerticalTab";
import { Blocks, BuilderBlock, isEditing } from "@builder.io/sdk-react";
import { BuilderProps } from "@/types/builder/BuilderProps";
import { BuilderBlockProps } from "@/types";
import { setTheme } from "@/helpers";

type VerticalTabBlockProps = {
  variant: "default" | "multiline";
  tabs: {
    label: string;
    head?: string;
    description?: string;
    dlt: string;
    dld: string;
    blocks: BuilderBlock[];
  }[];
  theme: "black" | "gray" | "white";
  tabHeader?: string;
  previousAnalytics?: { dlt: string; dld: string };
  nextAnalytics?: { dlt: string; dld: string };
  nextItem?: {
    displayNextItemLink?: boolean;
    nextItemText: string;
    dlt: string;
    dld: string;
  };
  shownFeatures?: number;
  pagerLabel?: string;
} & Pick<
  BuilderProps,
  "builderBlock" | "builderComponents" | "builderLinkComponent"
> &
  BuilderBlockProps;

export const VerticalTabBlock: FC<VerticalTabBlockProps> = ({
  variant = "default",
  tabs,
  theme,
  tabHeader,
  previousAnalytics,
  nextAnalytics,
  nextItem,
  shownFeatures,
  pagerLabel,
  builderBlock,
  builderComponents,
  builderLinkComponent,
  attributes,
}) => {
  return (
    <section {...setTheme(theme)} {...attributes}>
      <Suspense>
        <VerticalTab
          variant={variant}
          tabs={tabs}
          theme={theme}
          tabHeader={tabHeader}
          previousAnalytics={previousAnalytics}
          nextAnalytics={nextAnalytics}
          nextItem={nextItem}
          shownFeatures={shownFeatures}
          pagerLabel={pagerLabel}
          tabClickOverride={isEditing()}
        >
          {tabs?.map((tab, index) => (
            <div key={`${builderBlock?.id}-${tab.label}-${index}`}>
              <Blocks
                parent={builderBlock?.id}
                registeredComponents={builderComponents}
                path={`tabs.${index}.blocks`}
                blocks={tab.blocks || []}
                linkComponent={builderLinkComponent}
              />
            </div>
          ))}
        </VerticalTab>
      </Suspense>
    </section>
  );
};
